import React from 'react';
import { FormState } from '../../types';
import { Status } from '../../utils/readiness';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/Card';
import { Badge } from '../ui/Badge';
import { Edit2 } from 'lucide-react';
interface Props {
  state: FormState;
  sectionStatuses: Record<string, Status>;
  onEditSection: (sectionId: string) => void;
}
export function ReviewSubmit({
  state,
  sectionStatuses,
  onEditSection
}: Props) {
  const ReviewCard = ({
    title,
    sectionId,
    status,
    children
  }: any) => <Card className="mb-4 border-slate-200 dark:border-slate-700 shadow-sm" data-id="element-261">
      <CardHeader className="py-3 px-4 border-b border-slate-100 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50 flex flex-row items-center justify-between rounded-t-xl" data-id="element-262">
        <div className="flex items-center space-x-3" data-id="element-263">
          <CardTitle className="text-sm" data-id="element-264">{title}</CardTitle>
          {status === 'Complete' && <Badge variant="success" data-id="element-265">Complete</Badge>}
          {status === 'Missing Info' && <Badge variant="warning" data-id="element-266">Missing Info</Badge>}
          {status === 'Blocked' && <Badge variant="error" data-id="element-267">Blocked</Badge>}
        </div>
        <button onClick={() => onEditSection(sectionId)} className="text-slate-400 dark:text-slate-500 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors" title="Edit Section" data-id="element-268">
          <Edit2 className="w-4 h-4" data-id="element-269" />
        </button>
      </CardHeader>
      <CardContent className="p-4 text-sm" data-id="element-270">{children}</CardContent>
    </Card>;
  const DataRow = ({
    label,
    value
  }: {
    label: string;
    value: string | boolean;
  }) => <div className="flex py-1" data-id="element-271">
      <span className="w-1/3 text-slate-500 dark:text-slate-400" data-id="element-272">{label}</span>
      <span className="w-2/3 font-medium text-slate-900 dark:text-slate-100" data-id="element-273">
        {value || '-'}
      </span>
    </div>;
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-274">
      <div className="col-span-1 md:col-span-2 lg:col-span-4" data-id="element-275">
        <ReviewCard title="Required Contacts" sectionId="contacts" status={sectionStatuses.contacts} data-id="element-276">
          <DataRow label="Borrower" value={`${state.borrowerFirstName} ${state.borrowerLastName}`} data-id="element-277" />
          <DataRow label="Email" value={state.borrowerEmail} data-id="element-278" />
          <DataRow label="Mobile" value={state.borrowerMobile} data-id="element-279" />
          <DataRow label="Pref. Contact" value={`${state.preferredContactMethod} (${state.preferredContactLanguage})`} data-id="element-280" />
          {state.loanPurpose === 'Purchase' && <>
              <DataRow label="Buyer's Agent" value={state.buyerAgent} data-id="element-281" />
              <DataRow label="Listing Agent" value={state.listingAgent} data-id="element-282" />
            </>}
          <DataRow label="Appraisal Co." value={state.appraisalCompanyName} data-id="element-283" />
        </ReviewCard>

        <ReviewCard title="Property & Transaction" sectionId="property" status={sectionStatuses.property} data-id="element-284">
          <DataRow label="Address" value={`${state.propertyStreet}, ${state.propertyState}`} data-id="element-285" />
          <DataRow label="Type" value={state.propertyType} data-id="element-286" />
          <DataRow label="Purpose" value={state.loanPurpose} data-id="element-287" />
          <DataRow label="Madison ECD" value={state.madisonECD} data-id="element-288" />
        </ReviewCard>

        <ReviewCard title="Loan Product" sectionId="product" status={sectionStatuses.product} data-id="element-289">
          <DataRow label="QM Type" value={state.qmType} data-id="element-290" />
          {state.qmType === 'Non-QM' && <DataRow label="Product Type" value={state.nonQmProductType} data-id="element-291" />}
          <DataRow label="Processing" value={state.processingType} data-id="element-292" />
        </ReviewCard>
      </div>
    </div>;
}